import { IMediaFiles } from 'src/types'
import { IProductByIdRespDto, IProductForm } from 'src/types/product.type'

const generateFormState = (
  product: IProductByIdRespDto,
  code?: string | undefined,
): IProductForm => ({
  name: product.name,
  description: product.description,
  product_type: product.product_type || '',
  code: code ?? product.code,
  gtin: product.gtin,
  image: {
    icon: product.image,
    file: null,
  },
  image_small: product.image_small,
  image_medium: product.image_medium,
  media: product.media.reduce<IMediaFiles>((acc, media) => [...acc, { ...media, file: null }], []),
  selectedJourney: product.journey && product.journey.id,
  selectedImpacts: product.impact_options.map((item) => ({
    id: item.impact_id,
    home_page_show: item.home_page_show,
    impact_page_show: item.impacts_page_show,
  })),
})

export { generateFormState }
